import { ChannelKickAdminResponse } from "../proto/ChannelKickAdmin_pb";
import { GroupKickAdminResponse } from "../proto/GroupKickAdmin_pb";
import store from "../store";
import { kickAdmin } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";
import { getStorage } from "../libs/storage";
import { STORAGE_USER_ID } from "../constants/localstorage";

export default class HandleRoomKickAdminResponse extends BaseHandler<GroupKickAdminResponse | ChannelKickAdminResponse> {
  handle() {
    const roomKickAdminResponse = this.response.toObject();
    const isMine = roomKickAdminResponse.memberId === getStorage(STORAGE_USER_ID);
    store.dispatch(
      kickAdmin({
        roomId: roomKickAdminResponse.roomId,
        memberId: roomKickAdminResponse.memberId,
        memberRights: (roomKickAdminResponse as GroupKickAdminResponse.AsObject).permission,
        isMine: isMine,
      })
    );
  }
}
